import React from 'react';

export default function ReceivedInvitationsIcon(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '42'}
      height={props.height ?? '42'}
      {...props}
    >
      <rect width="42" height="42" rx="21" fill="#DC4405" />
      <path
        d="M23.677 28.776H15.64C12.856 28.776 11 27.384 11 24.136V17.64C11 14.392 12.856 13 15.64 13H24.92C27.704 13 29.56 14.392 29.56 17.64V21.7"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9206 18.1035L22.0206 20.4235C21.5162 20.7942 20.9066 20.9942 20.2806 20.9942C19.6546 20.9942 19.045 20.7942 18.5406 20.4235L15.6406 18.1035"
        stroke="#F7F7F7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0664 30.5352C30.9994 30.5352 32.5664 28.9682 32.5664 27.0352C32.5664 25.1022 30.9994 23.5352 29.0664 23.5352C27.1334 23.5352 25.5664 25.1022 25.5664 27.0352C25.5664 28.9682 27.1334 30.5352 29.0664 30.5352Z"
        fill="white"
      />
      <path
        d="M29.0625 25.7236V28.2656"
        stroke="#DC4405"
        strokeWidth="0.7"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.752 27.0787L29.064 28.3477L30.376 27.0787"
        stroke="#DC4405"
        strokeWidth="0.7"
        strokeLinecap="round"
      />
    </svg>
  );
}
